export const ADD_BG_IMAGE = 'addBgImage';
export const REMOVE_BG_IMAGE = 'removeBgImage';


export const addBgImage = (payload) => ({
    type: ADD_BG_IMAGE,
    payload
});

export const removeBgImage = (payload) => ({
    type: REMOVE_BG_IMAGE,
    payload
});
